<template>
    <el-dialog title="选择图片" class="uploaderImgVariant" v-if="value" :visible.sync="value" width="1000px" append-to-body
        :before-close="onClose">
        <ul class="select-img" v-if="imgList.length">
            <li class="option" v-for="(item, index) in imgList" :key="item" @click="changeVariantSelectImg(item)">
                <div class="img-mask" v-if="variantCheckedImgUidList.includes(item)">
                    <i class="el-icon-upload-success el-true-check">
                        {{ getVariantSelectImgIndex(item) }}
                    </i>
                </div>
                <img :src="item" alt />
            </li>
        </ul>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="onClose">
                取 消
            </el-button>
            <el-button size="mini" type="primary" @click="saveVariantSelectImg">
                确 定
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { Baseurl } from '@/api/api/api'

export default {
    components: {},
    props: {
        value: {
            type: Boolean,
            default: false
        },
        imgList: {
            type: Array,
            default: () => []
        },
        activeImg: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            uploadAction: Baseurl + 'shopeeImage/uploadImage',
            customHeaders: { token: localStorage.getItem('token') },
            variantCheckedImgUidList: [] // 用数组来存储多选项
        }
    },
    computed: {},
    watch: {
        activeImg: {
            handler(newVal) {
                this.variantCheckedImgUidList = newVal;
            },
            deep: true
        }
    },
    created() {
        this.roleInfo = JSON.parse(localStorage.getItem('role'))
    },
    methods: {
        onClose() {
            this.variantCheckedImgUidList = [] // 清空选中的图片
            this.$emit('input', false)
        },
        changeVariantSelectImg(item) {
            // 如果图片已经被选中，则移除它；否则添加它到选中的数组中
            const index = this.variantCheckedImgUidList.indexOf(item)
            if (index > -1) {
                // 如果已选中，则移除
                this.variantCheckedImgUidList.splice(index, 1)
            } else {
                // 否则添加
                this.variantCheckedImgUidList.push(item)
            }
        },
        getVariantSelectImgIndex(item) {
            // 获取图片在选中的数组中的索引，返回索引+1作为序号
            const isHaveIndex = this.variantCheckedImgUidList.indexOf(item)
            return isHaveIndex + 1 // 如果图片已被选中，则返回该图片的序号
        },
        // 选择图片确定
        saveVariantSelectImg() {
            this.$emit('confirm', this.variantCheckedImgUidList) // 传递所有选中的图片
            this.onClose() // 关闭对话框并清空选中状态
        }
    }
}
</script>

<style lang="scss" scoped>
.select-img {
    width: 100%;
    height: 320px;
    overflow: auto;

    .option {
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        float: left;
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        position: relative;

        .img-mask {
            position: absolute;
            right: -17px;
            top: -7px;
            width: 46px;
            height: 26px;
            background: #13ce66;
            text-align: center;
            transform: rotate(45deg);

            .el-true-check {
                color: #fff;
                font-size: 12px;
                margin-top: 12px;
                transform: rotate(-45deg);
            }
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}

.custom-update {
    /deep/ .el-upload--picture-card {
        background: initial;
        border: initial;
        width: initial;
        height: initial;
        line-height: initial;
    }
}
</style>